"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BiLogger_1 = require("./BiLogger");
Object.defineProperty(exports, "BiLogger", { enumerable: true, get: function () { return BiLogger_1.BiLogger; } });
//# sourceMappingURL=index.js.map